import { TableCell, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';

interface TableStateRowProps {
  colSpan: number;
  isLoading: boolean;
  error: Error | null;
  emptyText: string;
}

/**
 * Строка-заглушка таблицы для состояний «загрузка», «ошибка», «пусто».
 * Рисуется вызывающим кодом только когда данных для строк нет.
 */
export function TableStateRow({ colSpan, isLoading, error, emptyText }: TableStateRowProps) {
  let text = emptyText;
  if (isLoading) {
    text = 'Загрузка…';
  } else if (error) {
    text = error.message;
  }
  return (
    <TableRow>
      <TableCell
        colSpan={colSpan}
        className={cn('py-8 text-center', !isLoading && error ? 'text-destructive' : 'text-muted-foreground')}
      >
        {text}
      </TableCell>
    </TableRow>
  );
}
